import React from "react";
import { SvgIcon } from "@mui/material";

const QuestionIcon = (props) => {
  return (
    <SvgIcon
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
      {...props}
    >
      <path
        className="question-1"
        d="M150.7558,277.08558a129.022,129.022,0,1,1,129.022-129.022A129.16784,129.16784,0,0,1,150.7558,277.08558Zm0-240.0405A111.01852,111.01852,0,1,0,261.77432,148.0636,111.1417,111.1417,0,0,0,150.7558,37.04508Z"
      />
      <path
        className="question-1"
        d="M103.12889,100.25784a51.70648,51.70648,0,0,1,10.6065-17.14212,47.8024,47.8024,0,0,1,16.44452-11.31923,54.93631,54.93631,0,0,1,21.53688-4.06375q15.36652,0,25.64512,4.28353A49.80719,49.80719,0,0,1,193.923,82.67615,38.66076,38.66076,0,0,1,202.90114,96.413a39.934,39.934,0,0,1,2.70769,13.73417q0,10.54821-2.70769,17.361a42.82018,42.82018,0,0,1-6.71,11.64757,44.8397,44.8397,0,0,1-8.87226,8.24228q-4.87036,3.41151-9.19526,6.81325a43.21279,43.21279,0,0,0-7.6826,7.80271,22.61467,22.61467,0,0,0-4.22569,10.98822v8.35084H137.00117v-9.88931a43.2054,43.2054,0,0,1,10.38493-26.70221,55.06569,55.06569,0,0,1,8.228-7.80361q4.32447-3.2954,8.0056-6.59258a29.44747,29.44747,0,0,0,5.95369-7.25192,18.2985,18.2985,0,0,0,2.05724-9.88931q0-10.10509-4.86992-14.94431-4.87035-4.83031-13.52595-4.83521a20.6906,20.6906,0,0,0-10.06816,2.309,20.19843,20.19843,0,0,0-6.92715,6.15391,26.9076,26.9076,0,0,0-4.00235,9.01018,45.60522,45.60522,0,0,0-1.29556,11.09678H99.12565A63.53653,63.53653,0,0,1,103.12889,100.25784Zm64.82154,94.28126v33.8438H133.97137V194.5391Z"
      />{" "}
    </SvgIcon>
  );
};

export default QuestionIcon;
